import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { OffsiteCampaignEndpoints } from '../constants/api-endpoints';
import { IOffsiteCampaign } from '../entities/offsiteCampaign';
import { generatePath } from 'react-router';

export const useGetOffsiteCampaignsQuery = (siteId: string) => {
  const query = useQuery(['offsite-campaigns', siteId], async () => {
    const result = await RestApi.get<IOffsiteCampaign[]>(
      generatePath(OffsiteCampaignEndpoints.OFFSITE_GET_LIST, { siteId }),
    );
    return result.data.filter(s => s.type !== 'bulkRetargeting');
  });
  return query;
};
